<template>
    <div>
        <v-container>
            <h2 class="subheading grey--text">Registro de Proveedor</h2>
            <v-dialog v-model="dialog_bloqueo" persistent width="500">
                <v-card class="elevation-0">
                    <v-toolbar class="mb-0" dark color="warning">
                        <v-toolbar-title>
                            {{$t('aviso')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <h2>{{$t('pagina_caduca')}}</h2>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!--     Diálogo Modal Persistente para Recortar la Imagen del Logo      -->
            <v-dialog v-model="dialog_img_logo" persistent scrollable max-width="1000px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-basic
                                mode="normal"
                                class="basic lg"
                                ref="clipper4"
                                :src="imageLogoURL">
                        </clipper-basic>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                @click="dialog_img_logo = false, get_image_recortada_logo()"
                        >{{$t('recortar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout align-center justify-center class="text-sm-center my-3">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            <v-icon
                                    right
                                    dark
                            >
                                airport_shuttle
                            </v-icon>
                            {{currentTitle}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-avatar
                                color="primary lighten-2"
                                class="subheading white--text align-self-center"
                                size="60"
                                v-text="$t('paso') + ' ' +  step + '/2'"
                        ></v-avatar>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-window
                            v-model="step"
                    >
                        <v-window-item :value="2">
                            <v-layout align-center justify-center class="text-sm-center">
                                <v-card>
                                    <v-form
                                            class="mb-4"
                                            @submit.prevent="alta_empresa()"
                                    >
                                        <v-layout row wrap>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        box
                                                        class="pt-2 pb-2 pl-2 pr-2"
                                                        v-model="name"
                                                        autofocus
                                                        prepend-inner-icon="business"
                                                        name="name"
                                                        :label="$t('company_name')"
                                                        :error-messages="errores.name"
                                                >
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        box
                                                        class="pt-2 pb-2 pl-2 pr-2"
                                                        v-model="companyAddress"
                                                        prepend-inner-icon="location_on"
                                                        name="companyAddress"
                                                        :label="$t('direccion')"
                                                        :error-messages="errores.companyAddress"
                                                >
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        box
                                                        class="pt-2 pb-2 pl-2 pr-2"
                                                        v-model="telephone"
                                                        prepend-inner-icon="phone"
                                                        name="telephone"
                                                        :label="$t('telefono')"
                                                        :error-messages="errores.telephone"
                                                >
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        box
                                                        class="pt-2 pb-2 pl-2 pr-2"
                                                        v-model="companyWebPage"
                                                        prepend-inner-icon="public"
                                                        name="companyWebPage"
                                                        :label="$t('pagina_web')"
                                                        :error-messages="errores.companyWebPage"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                        box
                                                        class="pt-2 pb-2 pl-2 pr-2"
                                                        v-model="email"
                                                        prepend-inner-icon="email"
                                                        name="email"
                                                        :label="$t('company_email')"
                                                        :error-messages="errores.email"
                                                >
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6 class="ingla pt-3 pb-3 pl-3 pr-3">
                                                <v-label>
                                                    {{$t('logotipo')}}
                                                </v-label>
                                                <br>
                                                <v-img
                                                        class="pt-3 pb-3"
                                                        :src="resultLogoURL"
                                                        v-if="resultLogoURL"
                                                        width="auto"
                                                        height="180"
                                                ></v-img>
                                                <br>
                                                <v-alert
                                                        :value="errores.companyLogo"
                                                        type="error"
                                                        outline
                                                        transition="scale-transition"
                                                >
                                                    {{errores.companyLogo}}
                                                </v-alert>
                                                <br>
                                                <v-btn
                                                        color="primary">
                                                    <clipper-upload
                                                            @input="dialog_img_logo = true"
                                                            accept="image/*"
                                                            v-model="imageLogoURL"
                                                    >
                                                        {{$t('subir_imagen')}}
                                                    </clipper-upload>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-btn
                                                :loading="loading"
                                                color="primary"
                                                type="submit"
                                        >{{$t('enviar')}}
                                        </v-btn>
                                    </v-form>
                                </v-card>
                            </v-layout>
                        </v-window-item>
                    </v-window>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VuejsClipper from 'vuejs-clipper'
    import ClipperFixed from "vuejs-clipper/src/components/clipper-fixed";
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.component('vue-phone-number-input', VuePhoneNumberInput)
    Vue.use(VuejsClipper ,{
        components: {
            clipperBasic: 'clipper-basic',
            clipperFixed: 'clipper-fixed',
            clipperUpload: 'clipper-upload'
        }
    })
    export default {
        name: "providerFromUser",
        data () {
            return {
                errores: [],
                step: 2,
                // Datos de la Empresa
                name: '',
                companyAddress: '',
                telephone: '',
                email: '',
                logo_imageUrl: '',
                companyLogo: '',
                companyWebPage: '',
                logo_imageName: '',
                logo_imageFile: '',

                resultLogoURL: '',
                imageLogoURL: '',

                dialog_img_logo: false,

                dialog_bloqueo: false,
                info: '',
                idUserAdminProvider: 0,
                idHost: 0,
                band_continue: false,
                loading: false
            }
        },
        created: async function(){
            await this.get_info_admin_supplier()
        },
        computed: {
            currentTitle () {
                switch (this.step) {
                    case 1: return this.$t('manager_data')
                    case 2: return this.$t('campany_data')
                    default: return this.$t('employee_data')
                }
            }
        },
        methods: {
            alta_empresa(){
                this.errores = []
                this.loading = true
                var bodyFormData = new FormData()
                var file_logo = null

                bodyFormData.set('idUserAdminProvider', this.idUserAdminProvider)
                bodyFormData.set('host', this.idHost)
                bodyFormData.set('name', this.name)
                bodyFormData.set('companyAddress', this.companyAddress)
                bodyFormData.set('telephone', this.telephone)
                bodyFormData.set('email', this.email)
                if (this.resultLogoURL != '' && this.resultLogoURL.length > 6) {
                    file_logo = this.dataURLtoFile(this.resultLogoURL, 'logo.jpeg')
                }
                bodyFormData.append('companyLogo', file_logo)
                bodyFormData.set('companyWebPage', this.companyWebPage)
                bodyFormData.set('companyScian', 1989)
                bodyFormData.set('companyClassification', 'companyClassification')
                bodyFormData.set('companyLatitude', 1989.1989)
                bodyFormData.set('companyLongitude', 1989.1989)
                bodyFormData.set('companyURLMap', 'companyURLMap')
                bodyFormData.set('companyValidity', '1989-09-11')
                bodyFormData.set('id_parque', '')
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/createCompanyProvider',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept-Language': this.language
                    },
                    data: bodyFormData
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        console.log('Datos del Proveedor dados de Alta Correctamente.')
                        this.$router.push({path: '/registro/proveedor/exito'})
                    })
                    .catch(error => {
                        console.log(error.response.data)
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        this.loading = false
                    })
            },
            get_info_admin_supplier: async function () {
                console.log('GET INFO NEW ADMIN SUPPLIER')
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getProvider/' + this.$route.params['token'] + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(ok => {
                        this.info = ok.data
                        if(ok.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        }
                        this.fill_fields(ok.data)
                    })
                    .catch(error => {
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        else
                        if(error.response.status == 404)
                        {
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'error')
                            this.$store.commit('snackbar_change_message', 'Token Inválido')
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .finally(() => (this.loading = false))
            },
            fill_fields(datos){
                if(datos.length > 0){
                    this.idUserAdminProvider = datos[0].id
                    this.idHost = datos[0].host
                    console.log(datos)
                }
            },
            get_current_date (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            pickFile_logo(){
                this.$refs.image_logo.click ()
            },
            onFilePicked_logo(e){
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.logo_imageName = files[0].name
                    if(this.logo_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.logo_imageUrl = fr.result
                        this.logo_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.logo_imageName = ''
                    this.logo_imageFile = ''
                    this.logo_imageUrl = ''
                }
            },
            get_image_recortada_logo() {
                const canvas = this.$refs.clipper4.clip();//call component's clip method
                this.resultLogoURL = canvas.toDataURL("image/jpeg", 0.3);//canvas->image
                console.log(this.resultLogoURL)
                this.dialog_img_logo = false
                this.dialog = true
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            }
        }
    }
</script>

<style scoped>
    .ingla {
        border-radius: 10px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 2px 2px 2px 2px;
        border-style: solid solid solid solid;
    }
</style>
